import { render, staticRenderFns } from "./NewAdmin.vue?vue&type=template&id=640763d3&scoped=true&"
import script from "./NewAdmin.vue?vue&type=script&lang=js&"
export * from "./NewAdmin.vue?vue&type=script&lang=js&"
import style0 from "./NewAdmin.vue?vue&type=style&index=0&id=640763d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640763d3",
  null
  
)

export default component.exports